import * as React from "react";
import MeetingReportSummaryEdit from "./ReportSummaryEdit";
import { MeetingObj } from "../../Entity/Objmeeting";
import ReportDetailView from "./ReportDetailview";
import MIPADatePicker from "../Common/datepicker";
import "./Report.scss";
import Moment from "react-moment";
import { Checkbox } from "office-ui-fabric-react/lib/Checkbox";
import ContactDetailView from "../ContactDetailView/ContactDetailView";

import { IContextualMenuItem } from "office-ui-fabric-react/lib/ContextualMenu";
import CRMEditFrom from "../Common/CRMEditFrom";
import { Helper } from "../../Utils/Helper";

export interface IProps {
  meeting?: MeetingObj;
  UpdateMethod;
  LogTitle;
  InsideCRM;
  CRMURL;
  Phrases;
  contactlinks;
  RefreshCRMData;
}
export interface IContextualMenuState {
  DetailCalloutVisible?: boolean;
  Summary: string;
  ShowEditWindow?: boolean;
}
export default class MeetingReport extends React.Component<
  IProps,
  IContextualMenuState,
  IContextualMenuItem
> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      DetailCalloutVisible: false,
      Summary: props.meeting.Summary,
      ShowEditWindow:false
    };
  }
  public render() {
// Themed styles for the example.



    //let firstDayOfWeek= DayOfWeek.Monday;
    let followupData = this.props.meeting.Followup;
    let meetingDate = this.props.meeting.ReportDate;
    // let contact = this.props.meeting.Contact;
    let company = this.props.meeting.Company;
    let rowcss = "ms-Grid-row miparow";
    let webpartbody =
      this.props.meeting.MeetingColmn < 0
        ? ["webpartbody", "overdue"].join(" ")
        : "webpartbody";

    let editlink;
    if(!window.IsMobileOperatingSystem()){
      if (this.props.InsideCRM) {
      editlink = (
        <a href="" title={this.props.Phrases.edit}
          className="editlink"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            window.parent.postMessage(
              {
                action: "edit",
                data: { type: "meeting", id: this.props.meeting.ID }
              },
              "*"
            );
          }}
        >
          <i className="ms-Icon ms-Icon--WindowEdit" />
        </a>
      );
    } else {    
      /*  
      */
      const host = window["teamcontext"]?.host;

      if (host != null && host !== undefined && host.toLowerCase().indexOf("teams") >= 0){
        editlink = (
        <a
          title={this.props.Phrases.edit}
          className="editlink"
          href="#"    
          onClick={(e)=>{this.OpenEditWindow(e);} }     
        >
          <i className="ms-Icon ms-Icon--WindowEdit" />
        </a>
      );
      }else{
          editlink = (
                  <a
                    title={this.props.Phrases.edit}
                    className="editlink"
                    href="#"    
                    onClick={(e)=>{e.preventDefault();e.stopPropagation(); this.setState({ ShowEditWindow: true });} }     
                  >
                    <i className="ms-Icon ms-Icon--WindowEdit" />
                  </a>
                );
      }       
    }
    }
    
    

    return (
      <> 
      <div className="webpart">
        <div className="webpartTitle">
          <span>{this.props.Phrases.title}</span>
          {editlink}
          <MeetingReportSummaryEdit
            savesummary={this.props.Phrases.savesummary}
            meeting={this.props.meeting}
            UpdateMethod={this.props.UpdateMethod}
            LogTitle={this.props.LogTitle}
          />
        </div>
        <div className={webpartbody}>
          <div className="ms-Grid">
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <ReportDetailView
                  meeting={this.props.meeting}
                  Phrases={this.props.Phrases}
                />
              </div>
            </div>
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm6">
                <div
                  className="dateleft"
                  title={this.props.Phrases.setfollowupdate}
                >
                  <MIPADatePicker
                    datevalue={followupData}
                    ChangeDate={date => {
                      this.UpdateMeetingValue(
                        this.props.meeting.ID,
                        date,
                        "MeetRepFollow",
                        "DateTime",
                        this.props.meeting.MeetingColmn
                      );
                    }}
                  />
                </div>
              </div>
              <div
                className="ms-Grid-col ms-sm6"
                title={this.props.Phrases.reportdate}
              >
                <Moment className="dateright" format="DD MMM YY">
                  {meetingDate}
                </Moment>
              </div>
            </div>

            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <ContactDetailView
                  contactName={this.props.meeting.Contact}
                  contactId={this.props.meeting.ContactId}
                  contactlinks={this.props.contactlinks}
                  crmurl={this.props.CRMURL}
                />
              </div>
            </div>
            <div className={rowcss}>
              <div className="ms-Grid-col ms-sm12">
                <div
                  title={company}
                  className={["company", "ellips"].join(" ")}
                >
                  {company}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="webpartfooter">
          <Checkbox
            className="checkbox"
            label={this.props.Phrases.markcomplete}
            onChange={() => {
              this.UpdateMeetingValue(
                this.props.meeting.ID,
                null,
                "MeetRepFollow",
                "DateTime",
                this.props.meeting.MeetingColmn
              );
            }}
          />
        </div>
      </div>
      {this.state.ShowEditWindow && (
        <CRMEditFrom onClose={(result) => {

          if(result.entity==='meeting' && result.id.toString()===this.props.meeting.ID.toString()){
            if(result.updated){
              this.props.RefreshCRMData(this.props.meeting.MeetingColmn,'Meetings');
            }
            this.setState({ ShowEditWindow: false });
          }
          
        }} 
        itemid={"meeting_"+this.props.meeting.ID}
        //</>URL={`/crmteam/entityview?id=${this.props.meeting.ID}&entity=meeting&page=dashboard&action=edit`}>
        URL={this.GetMeetingEditLink(this.props.meeting.ID)}>
        </CRMEditFrom>
        
      )}
      </>
     
    );
  }
  public UpdateMeetingValue(itemId, newValue, propName, type, col) {
    let obj = {
      listtitle: "CRM Meeting Report",
      ID: itemId,
      fieldslist: [
        {
          spfieldname: propName,
          spvalue: newValue,
          spfieldtype: type
        }
      ]
    };
    this.props.UpdateMethod(obj, col, false);
  }
  public handleLogChange = (event): void => {
    this.setState({ Summary: event.target.value });
  };
  public OpenEditWindow= (e): void => {
    //let url=`https://${window.location.host}/crmteam/entityview?id=${this.props.meeting.ID}&entity=meeting&page=dashboard&action=edit`;
    let url=this.GetMeetingEditLink(this.props.meeting.ID);
    Helper.OpenCRMEditWindow(e,url,(data)=>{
       if(data.result["saved"]){
        this.props.RefreshCRMData(this.props.meeting.MeetingColmn,'Meetings');
        }
    });
    
    /*
    e.preventDefault();e.stopPropagation();
    const width =window.innerWidth * 0.9;
    const height = Math.min(window.innerHeight * 0.8, 800);

    
    let dialogInfo = 
    { url: `https://${window.location.host}/crmteam/entityview?id=${this.props.meeting.ID}&entity=meeting&page=dashboard&action=edit`, 
      //title: "Dialog Title", 
      size: { width, height } }; 
      microsoftTeams.dialog.url.open(dialogInfo, (data) => {
        //console.log(result);
        if(data.result["saved"]){
        this.props.RefreshCRMData(this.props.meeting.MeetingColmn,'Meetings');
        }
      });
      */
  };
  public GetMeetingEditLink = (id) => {
      let url=`https://${window.location.host}/crmteam/entityview?id=${id}&entity=meeting&page=dashboard&action=edit`;
      return url;
    }
  /*public AddSummary=(event)=>{
    let summarytext=this.state.Summary;
    if (summarytext == "") {
      summarytext=this.props.LogTitle;
  }
  else {
    summarytext=this.props.LogTitle + "\n\n" + summarytext;
  }
    this.setState({Summary:summarytext});
  }*/
}
